export default [
  {
    title: 'Internal',
    purposeOfUse:
      'Authenticate your identity; create, maintain and secure your account with us; maintain your preferences.',
    included: 'Knowledge and Belief, Authenticating, Preference',
    examples: 'Passwords, PIN, mother’s maiden name, individual interests',
  },
  {
    title: 'Historical',
    purposeOfUse:
      'Complete a transaction or provide a service for which the personal information was collected; conduct analytics and modeling.',
    included: 'Personal history',
    examples:
      'Past claims, prior insurance carriers, prior addresses,  medical history, criminal history',
  },
  {
    title: 'Financial',
    purposeOfUse:
      'Process your billing; make payments; complete a transaction or provide a service for which the personal information was collected.',
    included: 'Account, Ownership, Transactional, Credit',
    examples:
      'Credit card number, bank account, records of real or personal property, credit, income, loan records, taxes',
  },
  {
    title: 'External',
    purposeOfUse:
      'Identify information to verify you; complete a transaction or provide a service for which the personal information was collected; deliver product offerings that may be relevant to you; conduct analytics.',
    included:
      'Identifying, Ethnicity, Gender, Demographic, Medical and Health, Physical Characteristics',
    examples:
      'Name, username, government issued identification, social security number, gender, browsing behavior, age range, income bracket, physical and mental health, medical records',
  },
  {
    title: 'Social',
    purposeOfUse:
      'Establish your communication preferences; complete a transaction or provide a service for which the personal information was collected; process your policy, account or claim.',
    included:
      'Professional, Criminal, Public Life, Family, Social Network, Communication',
    examples:
      'Job titles, work history, school attended, convictions, charges, marital and family status,  email, telephone recordings',
  },
  {
    title: 'Tracking',
    purposeOfUse:
      'Contact you; provide relevant information; provide a location-based product or service requested by you; conduct analytics.',
    included: 'Computer or Mobile Device, Contact, Location',
    examples:
      'IP Address, geolocation, email address, physical address, telephone number, country',
  },
];
